module.exports = __webpack_public_path__ + "WillowTreeTavern.jpg?2c8cfd4b1eabf626945427c2e16b42de";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/WillowTreeTavern.jpg
// module id = 573
// module chunks = 0